import React from 'react';
import { DiaryEntry } from './DiaryEntry';
export function DiarySection() {
  return <section className="py-12 md:py-20 bg-cream" data-id="element-34">
      <DiaryEntry index={0} date="Vor 4 Monaten" title="Das Problem" content={<>
            <p data-id="element-36">
              Mia leckt ständig ihre Lippen. Schluckt immer wieder. Morgens
              frisst sie Gras wie besessen, würgt dann gelbe Galle.
            </p>
            <p data-id="element-37">
              Ich bin verzweifelt. Der Tierarzt findet nichts Konkretes. "Leerer
              Magen", sagt er. Ich glaube ihm nicht ganz.
            </p>
          </>} data-id="element-35" />

      <DiaryEntry index={1} date="Vor 3 Monaten" title="Die Suche" content={<>
            <p data-id="element-39">
              Ich füttere sie jetzt abends später. Hilft ein bisschen – aber
              nicht wirklich.
            </p>
            <p data-id="element-40">
              Ich lese alles über Magensäure bei Hunden, über Magengeschwüre,
              über Übelkeit. Ich stoße auf Erfahrungsberichte über pflanzliche
              Futterzusätze mit Mariendistel und Artischocke. Ich bestelle es.
            </p>
          </>} data-id="element-38" />

      <DiaryEntry index={2} date="Vor 6 Wochen" title="Die Veränderung" content={<>
            <p data-id="element-42">
              Nach 10 Tagen: Mia leckt sich morgens kaum noch die Lippen. Kein
              Grasfressmarathon.
            </p>
            <p data-id="element-43">
              Nach 3 Wochen: kein Würgen mehr. Sie frisst ihr Futter ruhig und
              entspannt. Ich schaue jeden Morgen ungläubig zu.
            </p>
          </>} data-id="element-41" />

      <DiaryEntry index={3} date="Heute" title="Unser neues Ritual" content={<>
            <p data-id="element-45">
              Das Topping gehört zu unserem Morgenritual. Ein Löffel ins Futter,
              fertig.
            </p>
            <p data-id="element-46">
              Mia ist ein anderer Hund – ruhig, entspannt, frisst mit Appetit.
              Keine Übelkeit mehr. Ich schlafe wieder durch.
            </p>
          </>} data-id="element-44" />
    </section>;
}